/**
 * @file HouseFilled.ts
 * @brief The Home icon: a solid house with the door cut out.
 *
 * @details
 * DES 12-10-2026 (option 11 of 20): solid, as iOS draws Home, so it stands
 * out beside the outlined Inbox in the Topbar. Same icon as the phone
 * (FRONTEND src/shared/components/icons/HouseFilled.tsx). Lucide House's
 * outline on the 24 grid, filled with currentColor, no stroke.
 *
 * @author DES
 * @date 12-10-2026
 */

import { createLucideIcon } from "lucide-react";

export const HouseFilled = createLucideIcon("HouseFilled", [
  [
    "path",
    {
      d: "M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2h-4v-5a3 3 0 0 0-6 0v5H5a2 2 0 0 1-2-2z",
      fill: "currentColor",
      stroke: "none",
      fillRule: "evenodd",
      key: "house",
    },
  ],
]);

export default HouseFilled;
